import * as React from 'react';
import useAppRouter from '@hooks/useAppRouter';
import PhotoCard from '@components/photo-card/PhotoCard';
import Text from '@components/common/Text';
import Spacing from '@components/common/Spacing';
import { useGetPhotoCardHotRandom } from '@src/apis/querys/photoCardHotRandomQuery';
import { useRealTimeRankingRegionStore } from '@src/stores/4cut-ranking/realTimeRankingStore';
import { getRegionName } from '@src/constants/region';
import styled from 'styled-components';
import { colorCode, font } from '@styles/styleUtils';
import Icon from '@src/svg/Icon';

const Wrap = styled.div`
  > div.photo-cards-carousel {
    display: flex;
    gap: 8px;
    overflow-x: scroll;
    padding: 0 20px 20px;
    ${({ theme }) => theme.hiddenScroll};
  }
`;

const TitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  > button {
    display: flex;
    align-items: center;
    ${font('caption2')};
    color: ${colorCode('gray60')};
  }
`;

interface Props {
  triggerClickPhotoCardGTM?: () => void;
  triggerClickMoreButtonGTM?: () => void;
}

/**
 * 실시간 '{region}' 지역 인기 참가자 Carousel
 * */
export default function PhotoCardCarousel({
  triggerClickPhotoCardGTM,
  triggerClickMoreButtonGTM,
}: Props) {
  const router = useAppRouter();

  const { region, data: mixedPhotoCard } = useGetPhotoCardHotRandom();
  const { updateRegion } = useRealTimeRankingRegionStore();

  const handleClickMore = () => {
    triggerClickMoreButtonGTM?.();
    updateRegion(region);
    router.push(`/ranking`);
  };

  if (!mixedPhotoCard || mixedPhotoCard?.length === 0) {
    return <></>;
  }

  return (
    <Wrap>
      <TitleWrap>
        <Text typo="heading2_bold" color="white">
          실시간 ‘{getRegionName(region)}’ 지역 인기 참가자
        </Text>
        <button type="button" onClick={handleClickMore}>
          <Text color="gray60" typo="caption2_regular">
            전체보기
          </Text>
          <Icon name="arrow-right" width={12} height={12} />
        </button>
      </TitleWrap>
      <Spacing size={16} />
      <div className="photo-cards-carousel">
        {mixedPhotoCard.map((card) => (
          <PhotoCard
            key={card.photoCardId}
            photoCardInfo={card}
            size="S"
            handleClick={() => {
              triggerClickPhotoCardGTM?.();
              router.push(`/photo-card/${card.photoCardId}`);
            }}
          />
        ))}
      </div>
    </Wrap>
  );
}
